import React from 'react'
import { ThemeProvider, Box } from 'pcln-design-system'
import PropTypes from 'prop-types'
import {
  Header as PartnerHeader,
  Footer as PartnerFooter,
  PartnerProvider,
} from '@pcln/whitelabel-components'

import { SearchErrorScreen } from '../listings-client/components/SearchErrorScreen'
import { ResponsiveChangeSearchHeaderWrapper } from '../listings-client/components/ResponsiveChangeSearchHeaderWrapper/ResponsiveChangeSearchHeaderWrapper'

import { getTheme } from '../common/getTheme'
import { buildPassengerInfo } from '../listings-client/services/airSearch/airSearchRequest/helpers'
import { useFeature } from '@pcln/feature-components'

const NoResultsMessage = ({ pclnBootstrapData }) => {
  const {
    partner,
    partnerTrackerEnv,
    partnerProviderAppName,
    isMobile,
    isReshopExperience,
    offerToken,
    searchRequest,
  } = pclnBootstrapData || {}

  const urlParams = new URLSearchParams(window.location.search)
  const passengers = {
    adults: urlParams.get('num-adults'),
    children: urlParams.get('num-children'),
    infants: urlParams.get('num-infants'),
  }
  const defaultPassengers = buildPassengerInfo({ params: passengers })

  return (
    <ThemeProvider theme={getTheme()}>
      <PartnerProvider appName={partnerProviderAppName} partner={partner} env={partnerTrackerEnv}>
        {partner && <PartnerHeader partner={partner} isMobile={isMobile} />}
        <Box w={1}>
          <ResponsiveChangeSearchHeaderWrapper
            defaultTripSlices={[{}]}
            defaultPassengers={defaultPassengers}
            urlRoot={'/m/fly/search/'}
            isWhiteLabel={!!partner}
            isReshopExperience={isReshopExperience}
            pageName='no_results'
            queryParams={{
              'offer-token': offerToken || undefined,
            }}
            maxChildren={6}
            iframeEnabled={useFeature('whiteLabel.iframeEnabled', false)}
            hideFilter
          />
          <SearchErrorScreen
            isReshopExperience={isReshopExperience}
            phoneBookNumber={isReshopExperience ? '1 (800) 774-2354' : '1 (833) 264-3729'}
            showPhoneNumber={!partner}
            urlParams={searchRequest?.params}
          />
        </Box>
        {partner && <PartnerFooter partner={partner} />}
      </PartnerProvider>
    </ThemeProvider>
  )
}

NoResultsMessage.propTypes = {
  pclnBootstrapData: PropTypes.object,
}

export { NoResultsMessage }
